module.exports = __webpack_public_path__ + "static/media/ch.4abf3477.svg";